export const promisify = <
  TFunction extends (...args: unknown[]) => ReturnType<TFunction>
>(
  fn: TFunction
) => {
  return (...args: Parameters<TFunction>) => {
    return new Promise<ReturnType<TFunction>>((resolve, reject) => {
      try {
        const value = fn(...args);
        resolve(value);
      } catch (error) {
        reject(error);
      }
    });
  };
};
